<payee-popup [onCancel]="onClose">
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ "CASES_TABLE.CIVIL_LAWSUIT_DIALOG.TITLE" | translate }}</h1>
  </ng-template>

  <div class="dialog-content">
    <p class="intro">
      {{ introKey() | translate: { debtorName: data.debtor_name } }}
    </p>
    <p class="instructions">
      {{ instructionsKey() | translate: instructionsParams() }}
    </p>

    <div class="law-firm-section">
      <h2 class="law-firm-heading">
        {{ "CASES_TABLE.CIVIL_LAWSUIT_DIALOG.LAW_FIRM_HEADING" | translate }}
      </h2>
      <p class="law-firm-name">{{ data.contact.law_firm.name }}</p>
      @if (data.contact.law_firm.email) {
        <a
          class="law-firm-link"
          [href]="'mailto:' + data.contact.law_firm.email"
        >
          {{ data.contact.law_firm.email }}
        </a>
      }
      @if (data.contact.law_firm.phone) {
        <a
          class="law-firm-link"
          [href]="'tel:' + data.contact.law_firm.phone"
        >
          {{ data.contact.law_firm.phone }}
        </a>
      }
      @if (data.contact.law_firm.address) {
        <p class="law-firm-address">{{ data.contact.law_firm.address }}</p>
      }
    </div>
  </div>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [mat-dialog-close]="false"
    >
      {{ "CASES_TABLE.CIVIL_LAWSUIT_DIALOG.CLOSE" | translate }}
    </button>
  </ng-template>
</payee-popup>
